import { create } from 'zustand';
import api from '../api/api';
import { notificationApi } from '../api/notification';
import { createNotificationStream } from '../features/notifications/model';
let sseController = null,
  reconnectTimer = null,
  epoch = 0,
  readGeneration = 0;
export const useNotificationStore = create((set, get) => ({
  unreadCount: 0,
  revision: 0,
  loading: false,
  error: null,
  connectSse: async () => {
    const token = localStorage.getItem('POSTPOP_AUTH_TOKEN');
    if (!token || sseController || document.hidden) return;
    const controller = new AbortController(),
      startedEpoch = epoch;
    sseController = controller;
    const current = () =>
      !controller.signal.aborted &&
      epoch === startedEpoch &&
      localStorage.getItem('POSTPOP_AUTH_TOKEN') === token;
    try {
      const response = await fetch(`${api.defaults.baseURL}/notifications/stream`, {
        headers: { Authorization: `Bearer ${token}`, Accept: 'text/event-stream' },
        signal: controller.signal,
      });
      if (!response.ok) throw Error('SSE connection failed');
      const reader = response.body.getReader(),
        decoder = new TextDecoder(),
        consume = createNotificationStream((raw) => {
          if (!current()) return;
          try {
            JSON.parse(raw);
            set((s) => ({ revision: s.revision + 1 }));
            void get().fetchUnreadCount();
          } catch {
            /* Ignore malformed event, retain current badge. */
          }
        });
      while (current()) {
        const { done, value } = await reader.read();
        if (done) break;
        consume(decoder.decode(value, { stream: true }));
      }
    } catch (e) {
      if (current()) console.error('Notification connection unavailable');
    } finally {
      if (sseController === controller) {
        sseController = null;
        if (current() && !document.hidden)
          reconnectTimer = setTimeout(() => {
            reconnectTimer = null;
            void get().connectSse();
          }, 3000);
      }
    }
  },
  disconnectSse: () => {
    epoch++;
    readGeneration++;
    if (reconnectTimer) {
      clearTimeout(reconnectTimer);
      reconnectTimer = null;
    }
    if (sseController) {
      sseController.abort();
      sseController = null;
    }
  },
  fetchUnreadCount: async () => {
    const token = localStorage.getItem('POSTPOP_AUTH_TOKEN'),
      e = epoch,
      request = ++readGeneration;
    if (!token) return;
    const current = () =>
      e === epoch &&
      request === readGeneration &&
      localStorage.getItem('POSTPOP_AUTH_TOKEN') === token;
    try {
      const response = await notificationApi.getUnreadCount({
        suppressGlobalError: true,
        isSessionCurrent: current,
      });
      if (current()) set({ unreadCount: response.data.count });
    } catch {
      /* Keep existing badge on failed refresh. */
    }
  },
  setUnreadCount: (count) => {
    readGeneration++;
    set({ unreadCount: Math.max(0, count) });
  },
  decrementUnreadCount: () => {
    readGeneration++;
    set({ unreadCount: Math.max(0, get().unreadCount - 1) });
  },
  resetUnreadCount: () => {
    readGeneration++;
    set({ unreadCount: 0 });
  },
}));
